module.exports = __webpack_public_path__ + "img/3.3ee253a4.jpg";